/**
 * Where a browser opens a live room's chat socket: the live Worker's own
 * origin (`workers/live/index.ts`), never the API's, with the ticket the API
 * signed. The studio and the Watch page both open it here. A room is named by
 * its session's id (a webinar's first session keeps the webinar's own id).
 */
export function roomSocketUrl(liveOrigin: string, room: string, socket: "chat", ticket: string): string {
  const url = new URL(`/room/${encodeURIComponent(room)}/${socket}`, liveOrigin);
  url.protocol = url.protocol === "https:" ? "wss:" : "ws:";
  url.searchParams.set("t", ticket);
  return url.toString();
}

/** Where a door asks who is here, on the same origin and ticket, without opening a socket. */
export function roomHereUrl(liveOrigin: string, room: string, ticket: string): string {
  const url = new URL(`/room/${encodeURIComponent(room)}/here`, liveOrigin);
  url.searchParams.set("t", ticket);
  return url.toString();
}
